const keys = {
    // auth
    ACCESS_TOKEN: 'access_token',
    ISAGENT: 'isAgent',
    USER_NAME: 'user_name',
    NICK_NAME: 'nick_name',
    EXPIRES_TIME: 'expires_time',
    REMEMBER_ME: 'rememberMe',
    GREETINGS : 'greetings',

    // annoucement
    LOGIN_ANNOUCEMENTS: 'login_Annoucements',
    UNLOGIN_ANNOUCEMENTS: 'unlogin_Annoucements',
    PRIZE_ANNOUNCEMENT: 'prizeAnnouncement',
    READ_ANNOUNCEMENT: 'read_announcement',
    CHATSITEGROUP_ANNOUNCEMENT: 'chatsitegroup_announcement',

    //Deposit
    BANKCARD_DISABLE_ANNOUNCEMENT_DATA: 'bankCardDisableAnnouncementData',
    BANKCARD_DISABLE_ANNOUNCEMENT_CONFIRMED: 'bankCardDisableAnnouncementConfirm',

    // marquee
    LOGIN_MARQUEE: 'login_Marquee',
    UNLOGIN_MARQUEE: 'unlogin_Marquee',

    // Pop-up
    DONTSHOW_POPUP: 'dontshow_popup_',
    LOGIN_POPUP: 'login_popup',

    // login
    REGISTER_LINK_CODE: 'RegisterLinkCode',
    LOGIN_TYPE: 'LoginType',
    MERCHANT_CODE: 'MerchantCode',
    TELEGRAM_BOT: 'telegram_bot',

    // home
    PRIZE_DAILY_SIGNIN: 'prizeDailySignIn',
    PRIZE_LEADERBOARD: 'prizeLeaderboard',
    DEMO_LINK: 'DemoLink', //試玩

    // game
    LOTTERY_GAME_DATA: 'lottery_game_data',
    BLOCKCHAIN_GAME_DATA: 'blockChain_game_data',

    // menu
    MENU_GAME: 'menu_game',
    MERCHANT_BETTYPE: 'merchant_betType',
    SIDE_MENU_CLASS: 'side_menu_class',
    LEFT_MENU_STATE: 'left_menu_state',

    // colection
    COLLECTION_PREFIX: 'collection_',
    COLLECTION_INIT: 'collection_init_',

    // bet
    BET_LASTSELECTED: 'bet_lastSelected',
    BET_BETTYPE_LASTSELECTED: 'bet_betType_lastSelected',
    BET_BETTYPE_FASTMONEY: 'bet_betType_fastMoney',
    BET_BETTYPE_MULTIPLE: 'bet_betType_multiple',
    BET_BETTYPE_UNIT: 'bet_betType_unit',
    BET_INPUTBETTYPE_LASTSELECTED: 'bet_inputBetType_lastSelected',
    BET_INPUTBETTYPE_FASTMONEY: 'bet_inputBetType_fastMoney',
    BET_INPUTBETTYPE_FASTMULTIPLE: 'bet_inputBetType_fastMultiple',
    BET_INPUTBETTYPE_UNIT: 'bet_inputBetType_unit',
    BET_EXCLUDEBETTYPE_MULTIPLE: 'bet_excludeBetType_multiple',
    BET_EXCLUDEBETTYPE_UNIT: 'bet_excludeBetType_unit',
    BET_LUZHU_BETTYPE_MULTIPLE: 'bet_luzhuBetType_multiple',
    BET_LUZHU_BETTYPE_UNIT: 'bet_luzhuBetType_unit',
    BET_LOTTOGAMEHISTORY: 'bet_LottoGameHistory',
    BET_BETTYPE_HISTORY: 'bet_Bettype_History',
    BET_EXCLUDEBETTYPE_HISTORY: 'bet_ExcludeBettype_History',
    BET_ROADTREND_VISBLE: 'bet_roadTrend_visble',
    BET_MULTIBET_SELECTED_GAME: 'bet_multibet_selected_game',
    BET_CLIENT_TEMPLATE: 'bet_client_template',
    BET_AUDIO_MUTED: 'bet_audio_muted',
    BET_VERIFICATION: 'bet_verification',
    BET_EVER_VERIFIED: 'bet_ever_verified',
    BET_PREDICT_FASTMONEY: 'bet_predict_fastMoney',
    BET_PREDICT_GAMELIMIT: 'bet_predict_gameLimit',
    BET_LOTTOGAME_LASTSELECTED: 'bet_lottoGame_lastSelected',
    BET_INPUTBETTAB_LASTSELECTED: 'bet_inputBetTab_lastSelected',
    BET_DANTIAO_ENTRY: 'bet_dantiao_entry',
    BET_MILLIMODE_ENTRY: 'bet_millimode_entry',
    BET_AWARD_NOTIFY_ENTRY: 'bet_award_notify_entry',
    BET_SCRATCH_DRAW_ENTRY: 'bet_scratch_draw_entry',

    BET_AWARD_ENTRY: 'bet_award_entry',
    BET_ANIMAL_OLYMPIC: 'bet_animal_Olympic',

    //投注顯示模式
    BET_BIG_MODE: 'bet_big_mode',
    BET_EASY_MODE: 'bet_easy_mode',

    //racingCar
    SHOW_RACING_VIDEO: 'show_racing_video',
    OPEN_SOUNDS_MUTE: 'open_sounds_mute',

    API_PROXY: 'API_PROXY',
    LAST_VIEWED_PAGE: 'LAST_VIEWED_PAGE',

    // logo
    LOGO_FILEPATH_PC: 'logo_filepath_pc',
    LOGO_FILEPATH_MOBILE: 'logo_Filepath_mobile',

    LOGO_HOME_PAGE: 'logo_home_page',
    LOGO_SPEEDTEST_PAGE: 'logo_speedtest_page',
    LOGO_REGISTER_PAGE: 'logo_register_page',
    LOGO_LOGIN_PAGE: 'logo_login_page',
    DEFAULT_PLAYER_IMAGEHEAD: 'logo_security_image_head_page',

    KEY_WEBSITEINFO: 'key_websiteInfo',
    KEY_FAVICON: 'logo_website_favicon_page',
    KEY_WEBSITE_TITLE: 'key_website_title',
    // menu
    CONTRACT_TYPE: 'contract_type',
    DIVIDENDRECORD_STATE: 'dividendRecord_state',

    DAILY_PAY_RECORD_STATE: 'daily_pay_record_state',
    ALLOW_PAY_DIVIDEND_OUT_OF_PLATFORM: 'allow_pay_out_of_platform',

    FINANCIAL_DAY_DELIMITATION: 'FinancialDayDelimitation',

    UNREAD_ANNOUNCEMENT: 'UNREAD_ANNOUNCEMENT',
    UNREAD_ACTIVITY_COUNT: 'unread_activity_count', //未讀活動數量
    DAILYPAY_HINT_MESSAGE: 'daily_pay_hint_message',
    AGENTACTIVITY_NOTICE_TEAMREDPACKRAIN_COUNT: 'agentactivity_notice_teamredpackrain_count', //團隊紅包未領通知數量

    // 下載中心(後台掛機設置)
    AFK_CONFIG: 'AFK_CONFIG',

    IS_DEMO_SITE: 'is_demo_site',

    //VIP
    VIP_INFO: "vip_info",

    //換膚
    WEB_STYLE: 'web_style',
    SKIN_COLOR: 'skin_color',

    //略過交易協定
    SKIP_TRADEAGREEMENT: 'skip_TradeAgreement',
    LOTTO_GAME: 'lotto_game',

    //自動測速
    SPEED_TEST_CONFIG: 'speed_test_config',
    SPEED_TEST_URL_LIST: 'speed_test_url_list1', //20230301新增編碼, 避免正式站更新後前台顯示異常, 所以修改Key確保更新後會執行api, 後續更新可以修改回去
    EXTERNAL_GAME_NAMES: 'external_game_names',
    FATEST_H5_URL: 'fatest_h5_url',
    DONTSHOW_CHECKAPP_VERSION_TIPS: 'dontshow_checkapp_version_tips',

    ISPWA: 'IsPWA',

    // chat
    LAST_CHATROOMID: 'LAST_CHATROOMID',
    CHAT_OPENED_ROOM_INFO: 'CHAT_OPENED_ROOM_INFO',

    // chat site group
    CHAT_SITE_GROUP_SESSION_TOKEN: 'CHAT_SITE_GROUP_SESSION_TOKEN',

    LOGIN_RECORD: 'LOGIN_RECORD',

    // 登錄器
    LOGIN_ENTRY: "LOGIN_ENTRY",
    LOGIN_ENTRY_POP: "LOGIN_ENTRY_POP",

    // 下載中心彈窗
    DOWNLOAD_CENTER_AFK: 'DOWNLOAD_CENTER_AFK',

    // wallet
    HIDE_WALLET_AMOUNT: "HIDE_WALLET_AMOUNT",

    // codova
    CORDOVA_UPDATE_DONTSHOW: "CORDOVA_UPDATE_DONTSHOW",

    // activity float
    RED_PACKET_SOLITAIRE_CLOSED: 'redPacketSolitaireClosed',
    LION_KING_CONTEST_CLOSED: 'lionKingContestClosed',
    RED_PACK_RAIN_CLOSED: 'redPackRainClosed'
};

class Storage {
    constructor(storage) {
        this.support = null;
        this.storage = storage
    }

    _getSupport() {
        if (this.support === null) {
            let test = 'test';
            try {
                this.storage.setItem(test, test);
                this.storage.removeItem(test);
                this.support = true;
            } catch (e) {
                this.support = false;
            }
        }
        return this.support;
    }

    get(key, options) {
        if (!this._getSupport()) {
            return null;
        }

        let val = this.storage[key];
        if (!val) {
            return null;
        }

        val = _tryParseJson(val);
        if (typeof val === 'string') {
            return val;
        }

        //value有可能是boolean，需特別判斷
        if (val.expire && (typeof val.value === 'boolean' || val.value)) {
            //強制取得過期資料
            if (options && options.ignoreExpire) {
                return val.value;
            }

            let expireDate = new Date(parseInt(val.expire));
            let valid = expireDate instanceof Date && !isNaN(expireDate);
            if (valid && new Date() > expireDate) {
                return null;
            }

            return val.value;
        }

        return val;
    }

    set(key, val, expire) {
        if (!this._getSupport()) {
            return;
        }

        if (expire) {
            val = { value: val, expire: expire };
        }

        if (typeof val === 'object') {
            val = JSON.stringify(val);
        }

        this.storage[key] = val;
    }

    remove(key) {
        this.storage.removeItem(key);
    }
}


class TempStorage {
    constructor() {
        this.temp = {};
    }

    get(key) {
        let val = this.temp[key];
        if (!val) {
            return null;
        }

        //value有可能是boolean，需特別判斷
        if (val.expire && (typeof val.value === 'boolean' || val.value)) {
            let expireDate = new Date(parseInt(val.expire));
            let valid = expireDate instanceof Date && !isNaN(expireDate);
            if (valid && new Date() > expireDate) {
                return null;
            }

            return val.value;
        }

        return val;
    }

    set(key, val, expire) {
        if (expire) {
            val = { value: val, expire: expire };
        }

        this.temp[key] = val;
    }

    remove(key) {
        delete this.temp[key];
    }
}

function _tryParseJson(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return str;
    }
}

export const storage = {
    keys: keys,
    local: new Storage(localStorage),
    session: new Storage(sessionStorage),
    temp: new TempStorage(),
};
